import { doc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { BillingCycle, SubscriptionPlanId } from '../types/subscription';
import { db, functions } from './firebase';

export type PaytabsOrderScope = 'subscription' | 'student_payment';
export type PaytabsOrderStatus = 'CREATED' | 'PENDING' | 'COMPLETED' | 'FAILED' | 'CANCELLED';

export interface CreatePaytabsOrderResult {
  orderId: string;
  redirectUrl: string;
}

export interface PaytabsOrder {
  id: string;
  orderId: string;
  scope: PaytabsOrderScope;
  teacherId: string;
  studentId?: string;
  paymentId?: string;
  planId?: SubscriptionPlanId;
  cycle?: BillingCycle;
  amountEgp: number;
  currency: 'EGP';
  status: PaytabsOrderStatus;
  paytabsTranRef?: string;
  redirectUrl?: string;
}

export async function createPaytabsSubscriptionOrder(
  planId: SubscriptionPlanId,
  cycle: BillingCycle
): Promise<CreatePaytabsOrderResult> {
  const callable = httpsCallable<
    { planId: string; cycle: BillingCycle },
    CreatePaytabsOrderResult
  >(functions, 'createPaytabsSubscriptionOrder');
  const result = await callable({ planId, cycle });
  return result.data;
}

export async function createPaytabsStudentPaymentOrder(
  teacherId: string,
  paymentId: string
): Promise<CreatePaytabsOrderResult> {
  const callable = httpsCallable<
    { teacherId: string; paymentId: string },
    CreatePaytabsOrderResult
  >(functions, 'createPaytabsStudentPaymentOrder');
  const result = await callable({ teacherId, paymentId });
  return result.data;
}

export async function getPaytabsOrder(orderId: string): Promise<PaytabsOrder | null> {
  const snapshot = await getDoc(doc(db, 'paytabsOrders', orderId));
  return snapshot.exists()
    ? ({ id: snapshot.id, ...snapshot.data() } as PaytabsOrder)
    : null;
}

export async function redirectToPaytabs(redirectUrl: string): Promise<void> {
  window.location.assign(redirectUrl);
}

